import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Dermatology, Fellowship - Cosmetic Dermatology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Scar Removal Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Surgical Scar Revision Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MD - Dermatology, Fellowship - Laser Dermatology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Laser Scar Treatment Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, DNB - Dermatology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Acne Scar Treatment Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Scar Revision"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Dermatology, Fellowship - Aesthetic Medicine",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical Scar Treatment"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Scar Removal Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert comprehensive care for scar treatment and revision with advanced technology for minimal scarring and optimal results.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const ScarRemovalTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Scar Removal Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Comprehensive Scar Treatment with 95% Improvement Rate. Advanced Techniques for Smoother, Less Visible Scars.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Scar Treatment
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Improvement Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Options</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>3-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Visible Results</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "types", label: "Scar Types", icon: "🔍" },
              { id: "treatment", label: "Treatments", icon: "🎯" },
              { id: "procedure", label: "Procedures", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Scar Removal Treatment</span>
            </h2>
          </div>

          {/* What are Scars */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Scars and Scar Formation
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Scars are the visible marks left on the skin after a wound or injury has healed. They form as 
                part of the body's natural healing process when the skin repairs itself after trauma, surgery, 
                burns, or skin conditions like acne. Scar tissue is composed of collagen fibers that differ 
                from normal skin in texture, color, and flexibility.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Scar Formation Process</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Scars develop through three phases: inflammatory phase (first few days), proliferative 
                      phase (weeks to months), and maturation phase (months to years). The final appearance 
                      depends on multiple factors including wound depth, location, and individual healing.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15line",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Factors Affecting Scarring</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Age, skin type, genetics, wound location, infection, tension on wound, and nutritional 
                      status all influence how scars form and mature. Proper wound care significantly impacts 
                      final scar appearance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Scar Types & Characteristics */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Scars & Their Characteristics
            </h3>

            <div className="row">
              {[
                {
                  title: "Hypertrophic Scars", 
                  description: "Raised, red scars that remain within boundaries of original wound, often improve over time",
                  details: "Common after burns, trauma, or surgical incisions"
                },
                {
                  title: "Keloid Scars", 
                  description: "Overgrown scars extending beyond original wound boundaries, may continue growing",
                  details: "More common in darker skin types, genetic predisposition"
                },
                {
                  title: "Atrophic Scars", 
                  description: "Depressed or pitted scars that sit below surrounding skin surface",
                  details: "Common with acne, chickenpox, or certain skin conditions"
                },
                {
                  title: "Contracture Scars", 
                  description: "Tight scars that pull skin together, may affect mobility if over joints",
                  details: "Typically result from burns, can limit movement"
                },
                {
                  title: "Stretch Marks", 
                  description: "Linear scars from rapid skin stretching during growth, pregnancy, or weight changes",
                  details: "Technically called striae distensae"
                },
                {
                  title: "Acne Scars", 
                  description: "Various types including icepick, boxcar, and rolling scars from severe acne",
                  details: "Require specialized treatment approaches"
                }
              ].map((scar, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {scar.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {scar.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {scar.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Scar Types Detailed Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Scar Classification
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Normal Fine-Line Scars",
                    description: "Thin, pale scars following healing of clean surgical incisions or minor wounds",
                    treatment: "Silicone sheets, laser therapy, microdermabrasion"
                  },
                  {
                    type: "Keloid Scars",
                    description: "Aggressive scar growth beyond wound margins, often itchy or painful, genetic predisposition",
                    treatment: "Steroid injections, laser, cryotherapy, surgical excision"
                  },
                  {
                    type: "Hypertrophic Scars",
                    description: "Raised red scars confined to wound area, may improve over 6-24 months",
                    treatment: "Pressure therapy, silicone gels, steroid injections, laser"
                  },
                  {
                    type: "Atrophic Scars",
                    description: "Sunken scars from collagen loss, including icepick, boxcar, and rolling varieties",
                    treatment: "Fillers, subcision, laser resurfacing, microneedling"
                  },
                  {
                    type: "Contracture Scars",
                    description: "Tight scars from burns that pull skin together, may restrict movement",
                    treatment: "Z-plasty, skin grafts, tissue expansion, physical therapy"
                  },
                  {
                    type: "Stretch Marks (Striae)",
                    description: "Linear scars from rapid skin stretching, appear red initially then fade to white",
                    treatment: "Fractional laser, microneedling RF, topical retinoids"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors for Problematic Scars
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Common Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Surgical incisions and procedures</li>
                      <li style={{ marginBottom: "10px" }}>Trauma, cuts, and lacerations</li>
                      <li style={{ marginBottom: "10px" }}>Burns (thermal, chemical, electrical)</li>
                      <li style={{ marginBottom: "10px" }}>Severe acne or skin infections</li>
                      <li>Inflammatory skin conditions</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Genetic predisposition to keloids</li>
                      <li style={{ marginBottom: "10px" }}>Darker skin types (Fitzpatrick IV-VI)</li>
                      <li style={{ marginBottom: "10px" }}>Young age (higher collagen production)</li>
                      <li style={{ marginBottom: "10px" }}>Location on body (chest, shoulders, ears)</li>
                      <li>Poor wound care and infection</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Treatments
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Advanced non-invasive and minimally invasive techniques that improve scar appearance 
                    without surgery, suitable for various scar types and locations.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Topical Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Silicone gels and sheets</li>
                          <li style={{ marginBottom: "8px" }}>Topical steroids</li>
                          <li style={{ marginBottom: "8px" }}>Vitamin E and onion extract</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Prescription retinoids</li>
                          <li style={{ marginBottom: "8px" }}>Pressure garments</li>
                          <li style={{ marginBottom: "8px" }}>Sun protection creams</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>In-office Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Laser treatments (Fractional, CO2, PDL)</li>
                      <li style={{ marginBottom: "8px" }}>Microneedling with RF</li>
                      <li style={{ marginBottom: "8px" }}>Chemical peels</li>
                      <li>Dermal fillers for atrophic scars</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical & Advanced Treatments
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Scar revision surgery</li>
                      <li style={{ marginBottom: "10px" }}>Z-plasty and W-plasty techniques</li>
                      <li style={{ marginBottom: "10px" }}>Skin grafting and flaps</li>
                      <li style={{ marginBottom: "10px" }}>Tissue expansion</li>
                      <li>Keloid excision with radiation</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Injectables & Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Corticosteroid injections</li>
                      <li style={{ marginBottom: "10px" }}>5-FU and bleomycin injections</li>
                      <li style={{ marginBottom: "10px" }}>Cryotherapy for keloids</li>
                      <li style={{ marginBottom: "10px" }}>Subcision for depressed scars</li>
                      <li>Platelet-rich plasma (PRP) therapy</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Emerging Technologies:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Fractional micro-plasma technology</li>
                      <li style={{ marginBottom: "10px" }}>Stem cell therapy</li>
                      <li>Bio-stimulatory fillers</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Consultation",
                    activities: ["Scar assessment", "Treatment planning", "Pre-treatment care", "Realistic expectations"]
                  },
                  {
                    period: "Week 3-8",
                    title: "Active Treatment Phase",
                    activities: ["Regular treatment sessions", "Progress monitoring", "Combination therapies", "Side effect management"]
                  },
                  {
                    period: "Month 3-6",
                    title: "Healing & Improvement",
                    activities: ["Collagen remodeling", "Visible improvements", "Maintenance treatments", "Scar maturation"]
                  },
                  {
                    period: "Month 6-12",
                    title: "Final Results",
                    activities: ["Optimal results visible", "Long-term maintenance", "Sun protection", "Final assessment"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Post-treatment Care
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Scar Prevention</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Proper wound care and cleaning</li>
                      <li style={{ marginBottom: "10px" }}>Keep wounds moist with appropriate dressings</li>
                      <li style={{ marginBottom: "10px" }}>Avoid sun exposure on healing wounds</li>
                      <li>Use silicone sheets from early healing stage</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-treatment Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Strict sun protection with SPF 50+</li>
                      <li style={{ marginBottom: "10px" }}>Gentle skincare and avoidance of irritation</li>
                      <li style={{ marginBottom: "10px" }}>Regular moisturization</li>
                      <li>Follow-up appointments for assessment</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Can scars be completely removed?",
                  answer: "While it's not possible to completely remove a scar and restore skin to its exact pre-injury state, modern scar treatments can significantly improve scar appearance, making them much less noticeable. Most treatments can achieve 70-95% improvement in scar appearance. The goal of scar treatment is to make the scar flatter, softer, closer to your natural skin color, and less noticeable. Factors that determine how much improvement is possible include the scar type, age, location, size, your skin type, and genetic factors. New scars typically respond better to treatment than old, mature scars. A combination of treatments often yields the best results. While complete removal isn't possible, most patients achieve significant cosmetic improvement that greatly enhances their confidence and quality of life."
                },
                {
                  question: "What is the best treatment for acne scars?",
                  answer: "The best treatment for acne scars depends on the specific type of acne scars you have. For icepick scars (deep, narrow pits), TCA CROSS (Chemical Reconstruction of Skin Scars) is often most effective. For boxcar scars (wider depressions with sharp edges), fractional laser resurfacing or microneedling with RF provides excellent results. For rolling scars (broad depressions with sloping edges), subcision combined with fillers or microneedling works well. Most patients benefit from combination therapy addressing different scar types simultaneously. Common effective combinations include: Subcision + filler injection + fractional laser; Microneedling RF + PRP + topical retinoids; TCA CROSS + fractional CO2 laser. A dermatologist can assess your specific scar types and recommend the most appropriate combination approach for optimal results. Multiple sessions are usually required for significant improvement."
                },
                {
                  question: "How long does it take to see results from scar treatment?",
                  answer: "The timeline for seeing results from scar treatment varies significantly based on the treatment type and the scar characteristics. Topical treatments like silicone gels typically show initial improvement in 2-3 months, with optimal results after 6 months of consistent use. Laser treatments may show some improvement after the first session, but most require 3-6 sessions spaced 4-6 weeks apart, with final results visible 3-6 months after the last treatment. Microneedling typically requires 4-6 sessions every 4-6 weeks, with noticeable improvement after 2-3 sessions and final results 3 months after the last session. Surgical scar revision shows immediate improvement, but the final healed result takes 6-12 months to fully mature. It's important to have realistic expectations and understand that scar improvement is a gradual process that requires patience and often multiple treatment sessions."
                },
                {
                  question: "Are scar treatments painful?",
                  answer: "The level of discomfort during scar treatments varies by procedure, but most are well-tolerated with appropriate pain management. Topical treatments like silicone gels are completely painless. Laser treatments typically feel like quick rubber band snaps against the skin, and most patients describe the discomfort as mild to moderate. Topical numbing creams are applied before most laser procedures to minimize discomfort. Microneedling causes mild to moderate discomfort often described as a sandpaper-like sensation, and numbing cream is routinely used. Injections like steroids or fillers cause brief pinprick sensations. Surgical scar revision is performed under local anesthesia, so you're comfortable during the procedure, with manageable post-operative discomfort. Most patients find the discomfort of scar treatments very manageable, especially considering the significant cosmetic benefits achieved. Your provider will ensure you're as comfortable as possible throughout your treatment."
                },
                {
                  question: "What's the difference between keloid and hypertrophic scars?",
                  answer: "Keloid and hypertrophic scars are often confused but have important differences. Hypertrophic scars are raised, red scars that remain within the boundaries of the original wound. They typically develop within weeks of injury, may be itchy or painful, and often improve naturally over 6-24 months. Keloid scars, however, extend beyond the original wound boundaries and continue growing beyond the initial injury site. They can develop months or even years after the injury, rarely improve spontaneously, and have a strong genetic predisposition. Treatment approaches also differ: Hypertrophic scars often respond well to silicone sheets, pressure therapy, and steroid injections. Keloids are more challenging and typically require combination therapy including steroid injections, laser treatment, cryotherapy, and sometimes surgical excision followed by radiation. Keloids also have a much higher recurrence rate than hypertrophic scars. Proper diagnosis is crucial as treatment strategies differ significantly between these two scar types."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Improve Your Scars?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive scar treatment with advanced technology for optimal results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Dermatology: <strong>080-6541-7705</strong> | Plastic Surgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default ScarRemovalTreatment;